import {
  Box,
  Paper,
  Stack,
  Typography,
  useTheme,
  Collapse,
  IconButton,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CopyableTypography from "components/Typography/CopyableTypography";
import { ActivityType } from "generated-graphql/graphql";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useLocalStorageState } from "hooks/useLocalStorageState";
import { useFulfillmentDetails } from "../useFulfillmentDetails";

const getGeppettoAction = (activityType?: ActivityType) => {
  if (activityType === ActivityType.Geppetto) {
    return "inputData";
  }
  if (activityType === ActivityType.CollectEvidence) {
    return "collectEvidenceOfCompletion";
  }

  return "";
};

const GeppettoCommand = () => {
  const theme = useTheme();
  const { data } = useFulfillmentDetails();
  const { activityId } = useParams();
  const [isExpanded, setIsExpanded] = useLocalStorageState<boolean>(
    "fulfillment-geppetto-command-expanded",
    { defaultValue: true }
  );

  const viewingActivity = data?.tierIIReport.currentWorkflow?.activities.find(
    (a) => a.id === activityId
  );

  const isViewingGeppettoActivity =
    viewingActivity?.type === ActivityType.Geppetto ||
    viewingActivity?.type === ActivityType.CollectEvidence;

  const action = getGeppettoAction(viewingActivity?.type);

  const facilityId = data?.tierIIReport.facility.id;

  const reportKind = data?.tierIIReport.reportKind;

  const jobId = viewingActivity?.currentJob?.id;

  const credentialId =
    data?.tierIIReport.facility?.portalCredential?.credential?.id;

  const geppettoCommand = useMemo(
    () =>
      `encamp geppetto --action ${action} --reporting-year ${
        data?.tierIIReport.reportingYear
      } --report-kind ${reportKind} --facility-id ${facilityId} --job-id ${
        jobId ?? ""
      } --credential-id ${credentialId ?? ""}`,
    [action, facilityId, reportKind, jobId, credentialId]
  );

  if (!isViewingGeppettoActivity) return <></>;

  return (
    <Stack
      direction={"column"}
      component={Paper}
      elevation={0}
      sx={{ padding: theme.spacing(3) }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          cursor: "pointer",
        }}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Typography variant="h6">Geppetto Command</Typography>
        <IconButton size="small" sx={{ ml: 1 }}>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Box>

      <Collapse in={isExpanded}>
        <Box sx={{ mt: 3 }}>
          <CopyableTypography text={geppettoCommand} />
        </Box>
      </Collapse>
    </Stack>
  );
};

export { GeppettoCommand };
